import React from 'react'
import { Profiling } from './profiling'
import { Options } from './options'
import { Suggestions } from './suggestions'
import { Personal } from './personal'
import { About } from './about'
import { opts } from './mock'

export const Right = () => {
    const {user} = {}
    
    return (
      <div>
      <Suggestions />
      
      <About />
      <Options data={opts} title='Configuration' /> <br />
      <div className="sticky">
            <Profiling  />
      </div> 
      <Personal />   
        
    </div>
    )
  }

  
